import styled from '@emotion/styled';
import { shadowLight } from 'app/colors';

const BaseStyles = styled.div`
  ${({ styles }) => styles || ''}
  .Authform-wrapper {
    background-color: var(--color-background-white);
    border-radius: 8px;
    width: 328px;
    ${shadowLight};
    padding: 15px;
    margin: 33vh auto;
  }

  .Auth-inactivity-message {
    margin: 75px auto 22px;
    width: 328px;
    font-weight: 300;
    text-align: center;
    line-height: 130%;
    letter-spacing: -0.25px;
  }

  .Authform-wrapper-with-message {
    background-color: var(--color-background-white);
    border-radius: 8px;
    width: 328px;
    ${shadowLight};
    padding: 15px;
    margin: 0 auto 49vh;
  }

  .Authform-wrapper.verify-account {
    width: 400px;
    border: 1px solid var(--color-border-medium-light);
    ${shadowLight}
  }

  .Authform-header {
    text-align: center;
    line-height: 1.1em;
  }

  .Authform-subheader {
    margin-top: 18px;
  }

  .Authform-buttons-wrapper {
    margin-top: 5px;
    .Authform-buttons {
      display: flex;
    }
  }

  .Authform-loader {
    padding-bottom: 10%;
  }

  .Authform-actions {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 10px;
  }
  .Authform-actions.single-button-container {
    justify-content: flex-end;
  }

  .Authform-input {
    margin-top: 25px;
  }

  .Authform-password {
    margin-top: 21px;
  }

  .Authform-wrapper.verify-account .Authform-input label {
    margin-bottom: 0;
  }

  .Authform-button {
    margin-right: 0;
  }

  .Authform-success {
    line-height: 125%;
    margin-top: 15px;
  }

  .Authform-error {
    margin-top: 15px;
    text-align: center;
    color: var(--color-viz-cat-7-primary);
  }
  .Authform-external {
    min-height: 153px;
    .icon {
      display: flex;
      min-height: 100px;

      justify-content: center;
    }
    .label {
      text-align: center;
    }
  }
`;

export default function AuthForm({ children, styles, ...rest }) {
  return (
    <BaseStyles {...rest} styles={styles ?? null}>
      {children}
    </BaseStyles>
  );
}
